import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'performance_process',
  children: {
    reviews: {
      path: 'reviews',
      children: {
        review: {
          path: ':reviewId',
          children: {
            overview: {
              path: 'overview',
              children: {
                draft: {
                  path: 'draft',
                },
                insights: {
                  path: 'insights',
                },
                answers: {
                  path: 'answers',
                },
                heatmap: {
                  path: 'heatmap',
                },
                personalResults: {
                  path: 'personal_results',
                },
                teamInsights: {
                  path: 'team_insights',
                },
              },
            },
            settings: {
              path: 'settings',
            },
            target: {
              path: 'target/:targetId',
              children: {
                evaluation: {
                  path: 'evaluation/:evaluationId',
                },
                agreement: {
                  path: 'agreement/:agreementId',
                },
              },
            },
            completedReviews: {
              path: 'my_reviews/:evaluationId',
            },
            myResultsAgreement: {
              path: 'my_results/:targetId/agreement/:agreementId',
            },
            myResultsEvaluation: {
              path: 'my_results/:targetId/evaluation/:evaluationId',
            },
            myResults: {
              path: 'my_results',
              children: {
                evaluation: {
                  path: ':evaluationId',
                },
              },
            },
          },
        },
        templates: {
          path: 'templates',
          children: {
            template: {
              path: ':templateId',
              children: {
                settings: {
                  path: 'settings',
                },
              },
            },
          },
        },
      },
    },
  },
} as const satisfies Location
